const $ = jQuery.noConflict();

let variacionesCargadas = window.variaciones;

// Globals
const $summary = jQuery('.summary');
const $form    = jQuery('form.variations_form');

let isProgrammaticChange = false;
let sync_selects = true;
let sync_radio_buttons = true;

jQuery(document).ready(function ($) {

    // Si es producto simple, salimos
    if (!variacionesCargadas) return;

    const default_attrs = {};
    $form.find('.variations select').each(function () {
        const name = jQuery(this).attr('name');
        const val  = jQuery(this).val();
        if (val) default_attrs[name] = val;
    });

    const variation = variacionesCargadas.find(v =>
        Object.entries(default_attrs).every(([key, val]) => v.attributes[key] === val)
    );

    if (variation) {
        Object.entries(default_attrs).forEach(([name, val]) => {
            setRadioCheckedUI(name, val);
        });
        displayVariation(variation);
    }

    $form.off('change.wc-variation-form');

    $form.on('check_variations', function(evt) {
        evt.stopImmediatePropagation();
        evt.preventDefault();
        return false;
    });

    const orderedKeys = $form.find('.variations select').map(function() {
        return jQuery(this).attr('name');
    }).get();

    let lastChangedAttr = null;

    $form.on('click', '.sc-radio-pill', function (e) {
        const $radio = jQuery(this).find('input[type=radio]');
        if (!$radio.length || $radio.prop('disabled')) return;
        setRadioCheckedUI($radio.attr('name'), $radio.val());
        $radio.trigger('change');
    });

    // ——— Cambio en SELECT -> sincroniza radio equivalente + lógica de variación
    $form.on('change', '.variations select', function () {

        sync_radio_buttons_attrs(this); // pone checked en el radio y actualiza estilos

        if (isProgrammaticChange) return;

        lastChangedAttr = jQuery(this).attr('name');
        const currentAttrs = getCurrentAttributes();

        const exactMatch = findMatchingVariation(currentAttrs);

        if (exactMatch) {
            displayVariation(exactMatch);
        } else {
            const closestMatch = findClosestMatch(currentAttrs, lastChangedAttr, orderedKeys);
            if (closestMatch) {
                setVariationAttributes(closestMatch.attributes);
                displayVariation(closestMatch);
            } else {
                showNotAvailableMessage();
            }
        }

        disable_unavailable_options(lastChangedAttr);
    });

	$form.on('change', '.sc-variation-radios input', function () {
        // Actualiza UI (checked + clases)
        setRadioCheckedUI(jQuery(this).attr('name'), jQuery(this).val());
        sync_selects_attrs(this);
	});
});

/* ================= helpers ================= */

function setRadioCheckedUI(name, value) {
    // Desmarcar todos los radios del mismo atributo
    const $all = jQuery(`.sc-variation-radios input[name="${name}"]`);
    $all.prop('checked', false).attr('aria-checked', 'false')
        .closest('.button-group, .sc-radio-pill').removeClass('is-checked selected active');

    // Marcar el radio objetivo (si existe)
    const id = `${name}-${value}`;
    const $target = jQuery(`.sc-variation-radios #${CSS.escape(id)}`);
    if ($target.length) {
        $target.prop('checked', true).attr('aria-checked', 'true');
        $target.closest('.button-group, .sc-radio-pill').addClass('is-checked selected active');
        // Marca visual del circulito si lo usas
        const $outer = $target.siblings('.outer-circle');
        $outer.toggleClass('checked', true);
    }

    // Asegurar que los no seleccionados no tengan el estado visual
    $all.each(function(){
        if (this !== $target.get(0)) {
            jQuery(this).siblings('.outer-circle').removeClass('checked');
        }
    });
}

function disable_unavailable_options(lastChangedAttr) {

    const $lastInput = jQuery(`.sc-variation-radios input[name="${lastChangedAttr}"]:checked`);
    const lastValue  = $lastInput.val();

    // Si no hay selección, no hacemos nada
    if (!lastValue) return;

    const matchingVariations = variacionesCargadas.filter(variation =>
        variation.attributes[lastChangedAttr] === lastValue
    );

    // Determinar valores válidos por atributo
    const validOptions = {};
    matchingVariations.forEach(variation => {
        jQuery.each(variation.attributes, function (attr, val) {
            if (!validOptions[attr]) validOptions[attr] = new Set();
            validOptions[attr].add(val);
        });
    });

    const lastChangedAttr_index = jQuery(`select[name="${lastChangedAttr}"]`).closest('tr').data('index');

    jQuery('.sc-variation-radios input').each(function () {
        const $radio = jQuery(this);
        const attr   = $radio.attr('name');
        const val    = $radio.val();
        const $wrap  = $radio.closest('.button-group, .sc-radio-pill');

        const attr_index = jQuery(`select[name="${attr}"]`).closest('tr').data('index');

        // Solo deshabilitar atributos que vengan después del cambiado
        if (typeof attr_index !== 'undefined' && typeof lastChangedAttr_index !== 'undefined') {
            if (attr_index <= lastChangedAttr_index) return;
        }
        if (attr === lastChangedAttr) return;

        const isValid = !validOptions[attr] || validOptions[attr].has(val);
        $radio.prop('disabled', !isValid);

        if (!isValid) {
            $wrap.addClass('disabled').removeClass('is-checked selected active');
            $radio.attr('aria-disabled', 'true');
        } else {
            $wrap.removeClass('disabled');
            $radio.removeAttr('aria-disabled');
        }
    });
}

function sync_selects_attrs(radio_btn) {
    const name  = jQuery(radio_btn).attr('name');
    const value = jQuery(radio_btn).val();

    if (!sync_selects) return;

    // Evita rebote: el cambio de select no debe volver a tocar el radio
    sync_radio_buttons = false;
    jQuery(`select[name="${name}"]`).val(value).trigger('change');
    sync_radio_buttons = true;
}

function sync_radio_buttons_attrs(select) {
    const name  = jQuery(select).attr('name');
    const value = jQuery(select).val();

    if (!sync_radio_buttons) return;
    if (!value) return;

    // Actualiza UI del radio (checked + clases) sin provocar cambio del select
    sync_selects = false;
    setRadioCheckedUI(name, value);
    sync_selects = true;
}

function getCurrentAttributes() {
    const attrs = {};
    $form.find('.variations select').each(function() {
        const name = jQuery(this).attr('name');
        const val  = jQuery(this).val();
        if (val) attrs[name] = val;
    });
    return attrs;
}

function findMatchingVariation(attrs) {
    return variacionesCargadas.find(variation =>
        Object.entries(attrs).every(([key, val]) =>
            variation.attributes[key] === val
        )
    );
}

function findClosestMatch(attrs, changedKey, orderedKeys) {
    let posibles = variacionesCargadas.filter(variation =>
        variation.attributes[changedKey] === attrs[changedKey]
    );

    if (orderedKeys.length === 1) return posibles[0] || null;

    for (let i = orderedKeys.length - 1; i >= 0; i--) {
        const currentKeys = orderedKeys.slice(0, i + 1); 
        const filtered = posibles.find(variation => {
            return currentKeys.every(key => {
                if (key === changedKey) return true; 
                if (!attrs[key]) return true;        
                return variation.attributes[key] === attrs[key]; 
            });
        });
        if (filtered) return filtered;
    }

    return posibles[0] || null;
}

// Sincroniza selects con una variación (evita loops)
function setVariationAttributes(attrs) {
    isProgrammaticChange = true;
    sync_radio_buttons = true;
    $form.find('.variations select').each(function() {
        const name = jQuery(this).attr('name');
        const val  = attrs[name];
        if (val && jQuery(this).val() !== val) {
            jQuery(this).val(val).trigger('change');
        }
    });
    sync_radio_buttons = false;
    isProgrammaticChange = false;
}

/* ===== Hooks existentes (no tocados) ===== */

$(".variations_form").on("show_variation", function (event, variation) {
    const isMobile = window.innerWidth < 1024 ? true : false;
    if (!isMobile) {
        setTimeout(function() {
            const $art_thumbnail_img = $('.product.is-art .woo-variation-gallery-slider .wvg-single-gallery-image-container').first();
            if ($art_thumbnail_img.closest('.zoom-wrap').length == 0) {
                $art_thumbnail_img.wrap('<span class="zoom-wrap" style="display:block"></span>').parent().zoom({magnify: 1});
            }
        }, 1000);
    }
});

function displayVariation(variation) {
    // Dispara hooks
    $form.trigger('found_variation', [variation]);
    $form.trigger('show_variation', [variation]);

    // Klarna
    /* const klarna_price = variation.display_price;
    if (klarna_price) {
        jQuery("klarna-placement").attr('data-purchase-amount', klarna_price * 100);
    } */

    // SKU
    $(".sku_wrapper .sku").text(variation.sku);

    let price = variation.price_html || variation.display_regular_price;
    price = price != null ? price.toString() : '';
    $summary.find('.woocommerce-variation-price').html(price);

    $summary.find(`.wcpbc-price-${variation.variation_id}`).removeClass('loading');

    $summary.find('input[name=variation_id]').val(variation.variation_id);
}

function showNotAvailableMessage() {
    $form.trigger('reset_data');
    $form.trigger('hide_variation');
    //alert('Variación no disponible');
}

// Hook placeholder (si lo necesitas más adelante)
$(".variations_form").on("show_variation", function (event, variation) { });
